export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.announcements': '公告',
  'menu.policies': '制度',
  'menu.supplies': '物資',
  'menu.supplies.workbench': '工作臺',
  'menu.supplies.inventory': '庫存中心',
  'menu.supplies.receive': '領用管理',
  'menu.supplies.purchase': '採購管理',
  'menu.supplies.check': '盤點管理',
  'menu.supplies.rule': '規則中心',
  'menu.supplies.statistics': '統計分析',
  'menu.supplies.workflow': '審批中心',
  'menu.meetings': '會議',
  'menu.meetings.calendar': '個人中心',
  'menu.meetings.bookings': '預約列表',
  'menu.meetings.rooms': '會議室列表',
  'menu.meetings.minutes': '會議紀要',
  'menu.meetings.reports': '利用率報告',
  'menu.meetings.dashboard': '工作台',
  'menu.meetings.settings': '設置',
  'menu.meetings.settings.booking': '預定規則配置',
  'menu.meetings.settings.facilities': '會議室設置',
  'menu.meetings.settings.locations': '位置與樓層',
  'menu.meetingRoomDashboard': '工作台',
  'menu.meetingRoomRooms': '會議室列表',
  'menu.meetingRoomBookings': '預約列表',
  'menu.meetingRoomCalendar': '個人中心',
  'menu.meetingRoomMinutes': '會議紀要',
  'menu.meetingRoomUtilizationReport': '利用率報告',
  'menu.meetingRoomSettings': '設置',
  'menu.meetingRoomBookingConfig': '預定規則配置',
  'menu.meetingRoomFacilityTags': '會議室設置',
  'menu.meetingRoomLocationConfig': '位置與樓層',
  'menu.meetingRoomFloorPlan': '樓層圖',
  'menu.greenPlants': '綠植',
  'menu.greenplant': '綠植管理',
  'menu.greenplant.dashboard': '綠植工作台',
  'menu.greenplant.assets': '綠植台帳',
  'menu.greenplant.spacePoints': '空間點位',
  'menu.greenplant.tasks': '養護與異常',
  'menu.greenplant.issues': '異常處理',
  'menu.greenplant.insights': '營運洞察',
  'menu.greenplant.settings': '配置中心',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '系統設置',
  'menu.settings.modelSettings': '模型設定',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
